/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LostInputs */

const cs_enum_lost = /** @type {(inputs: Enum_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ztracen`)
};

const en_enum_lost = /** @type {(inputs: Enum_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost`)
};

/**
* | output |
* | --- |
* | "Lost" |
*
* @param {Enum_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lost = /** @type {((inputs?: Enum_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lost(inputs)
	return cs_enum_lost(inputs)
});